import { useEffect } from "react";
import type React from "react";
import { startComposerDraftMaintenance } from "./draftMaintenance";

export const ComposerDraftMaintenance: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  useEffect(() => startComposerDraftMaintenance(), []);
  return <>{children}</>;
};
